import React from 'react';
import { Container } from './styles';

function Footer() {
    return (
        <Container />
    );
}

export default Footer;